import { Injectable } from "@angular/core";
@Injectable()
export class EFileApplicationDto {
    applicationId: number;
    assessmentNumber: string;
    parcelNumber: string;
    applicationNumber: string;
    propertyLocation: string;
    propertyLocationView: string;
    applicantName: string;
    agentName: string;
    applicationStatus: string;
    filingStatus: string;
    typeOfAssessmentId: number;
    typeOfAssessment: string;
    dateUpdated: Date;
    username: string;
    streetNumber: string;
    streetAddress: string;
    city: string;
    unit: string;
}